export const LOCAL_AREA_LANDSCAPES = {
  exeter:
    'The Exe valley and the rise toward the Blackdown Hills shape how people move between the campus quarter, Southernhay and the M5 corridor.',
  plymouth:
    "Plymouth Sound, the Tamar and the South Hams coastline frame Britain's Ocean City—sea and estuary drive marine, defence and hospitality searches.",
  torbay:
    'Torbay’s curved bay system—the English Riviera—packs marinas, beaches and cliff-top towns into one tight coastal footprint.',
  torquay:
    'Sheltered bays and a palm-lined seafront give Torquay a resort backdrop where hospitality and marine trades compete for seasonal and year-round traffic.',
  paignton:
    'Paignton blends sandy beaches with gentler inland slopes toward the Dart valley—holiday demand and residential services sit side by side.',
  barnstaple:
    'The Taw–Torridge estuary plain meets Exmoor’s southern edge, setting the scene for North Devon retail, logistics and countryside tourism.',
  'newton-abbot':
    'The Teign cuts through from moor fringes toward the coast, linking Dartmoor-edge communities with south Devon’s markets.',
  tiverton:
    'Mid-Devon hills and the Grand Western Canal corridor place Tiverton between Exeter and the north coast’s Atlantic cliffs.',
  bideford:
    'The Torridge estuary and Atlantic headlands make Bideford a crossing point between Tarka Country, the coast and Hartland’s high cliffs.',
  teignmouth:
    'The Teign meets Lyme Bay below the Ness, with coastal routes tying the estuary mouth to Exeter and the south Devon shore.',
  exmouth:
    'The Exe opens into Lyme Bay beside the Jurassic coast’s western cliffs—dunes, seafront and wintering wildlife define the setting.',
  dawlish:
    'The famous sea wall threads the town between red sandstone cliffs and breaking surf—an exposed Teign-side line to storms and tourism peaks.',
  totnes:
    'The Dart valley tightens through Totnes toward Dartmouth, with wooded slopes and tidal reaches behind a strong independent retail scene.',
  dartmouth:
    'Steep rivermouth hills frame where the Dart meets the sea—classic South Hams geography for sailing, hospitality and second homes.',
  kingsbridge:
    'Kingsbridge sits at the head of a branching ria system in the South Hams—creeks, saltings and rolling farmland behind the coast.',
  salcombe:
    'Sheltered ria inlets and wooded hills make Salcombe one of the UK’s densest pockets of marine leisure and high-end hospitality.',
  honiton:
    'The Otter valley and dip-slopes toward the Blackdown Hills put Honiton between agrarian east Devon and the A30 corridor.',
  seaton:
    'The Axe valley meets the Undercliff and Lyme Bay’s Jurassic shingle—fossil cliffs and coastal paths drive seasonal discovery.',
  sidmouth:
    'Regency seafront below High Peak and red mudstone cliffs gives Sidmouth a quieter east-Devon coastal character than open-bay neighbours.',
  'south-molton':
    'Rolling pasture on the edge of Exmoor’s heather and combes makes South Molton a market hub for upland farms and moor-bound visitors.',
  axminster:
    'The Axe and Yarty valleys knit Axminster into the Devon–Dorset border hills, with the Jurassic coast a few miles south.',
  okehampton:
    'Dartmoor rises directly north—granite tors and open moor make Okehampton the main gateway for walking, cycling and outdoor trade.',
  tavistock:
    'The Tavy valley cuts through western Dartmoor fringes, linking river mills and moor-edge farms with the Tamar borderlands.',
  crediton:
    'The rolling Creedy valley feeds the Exe catchment, placing Crediton amid mid-Devon dairy country and commuter spokes toward Exeter.',
  ilfracombe:
    'Steep combes drop to a rugged north-Devon harbour where the Bristol Channel swells—cliffs, tunnels and wilder beaches set the scene.',
  cullompton:
    'The Culm valley threads mid-Devon between the Blackdowns and the Exe, with M5 growth meeting an older market-town core.',
  ivybridge:
    'The Erme corridor climbs toward southern Dartmoor—moor edge, woodland and the Plymouth commute shape how people search locally.',

  truro:
    'Kenwyn and Allen streams meet in Cornwall’s only city, with wooded valleys draining toward the Fal and Restronguet creeks.',
  falmouth:
    'Carrick Roads—one of the world’s deepest natural harbours—opens drowned valleys to the Atlantic, tying Falmouth to maritime research and beaches.',
  penzance:
    'Mount’s Bay sweeps from the Lizard toward Marazion’s tidal causeway—a granite coast backdrop for fishing, freight and tourism.',
  newquay:
    'Atlantic swells meet north-Cornwall headlands and dune-backed bays—exposed coast drives surf, nightlife and visitor demand.',
  'st-austell':
    'China-clay pits and bright tips puncture the bay hinterland between wooded valleys and the south coast’s sheltered coves.',
  camborne:
    'Camborne–Redruth sits on the granite spine toward the north coast—mining heritage, heath and Atlantic gales beyond Portreath.',
  redruth:
    'Inland ridges carry old mineral railways through heathland toward St Agnes Head’s engine-house skyline above the Atlantic.',
  bodmin:
    'Bodmin Moor’s tors loom north while the Fowey and Camel headwaters drain south—a plateau between two different Cornish coasts.',
  helston:
    'The Lizard gateway opens from the Cober levels toward Loe Pool and the gentler south coast—windswept moors lie close to the west.',
  liskeard:
    'Southeast moorland fringes and the upper Fowey–Tamar watershed make Liskeard granite-country before the land falls to the sea.',
  launceston:
    'The upper Tamar runs narrow on the Devon border—tree-lined gorge country above rolling pasture defines the historic gateway west.',
  saltash:
    'Brunel’s bridges span the Tamar narrows where creeks meet deep-channel shipping—Plymouth Sound’s edge frames Saltash views.',
  torpoint:
    'The Rame peninsula’s wooded shores face Devonport across the Hamoaze, with ferries linking Cornish lanes to city docks.',
  wadebridge:
    'The Camel Trail follows a drowned valley toward Padstow—estuary mudflats and Stepper Point cliffs bracket north Cornwall’s inner coast.',
  padstow:
    'The Camel estuary mouth funnels Atlantic tides between Stepper and Trevose Head—rock pools, dunes and fleets shape the harbour economy.',
  bude:
    'Summerleaze and Crooklets face the full Atlantic where Cornwall narrows—high cliffs, canal heritage and surfing beaches mark the far north.',
  'st-ives':
    'Porthmeor’s light and granite headlands cut St Ives Bay’s coves—Atlantic surf, fishing fleets and steep lanes pack into one tight town.',
  hayle:
    'Three miles of estuary sand and Towans link the Hayle river mouth to Godrevy—dunes, tidal flats and big skies face the Atlantic.',
  callington:
    'Kit Hill and the upper Tamar–Lynher ridges rise east of town—mining country between Dartmoor’s edge and softer creeks toward Plymouth.',
  lostwithiel:
    'The Fowey runs through wooded valleys below Restormel—oak-lined gorges and salmon pools typify this mid-Cornwall corridor.',
  looe:
    'Twin towns straddle a wooded ria—tight harbours where the Looe rivers meet before opening to Channel swells.',
  fowey:
    'A deep ria runs east past Polruan—steep wooded hills, china-clay shiploaders and narrow harbours frame one of Cornwall’s steepest ports.',
  perranporth:
    'Atlantic beach and dunes back the village along stream-cut valleys—open sands contrast the north coast’s tucked-away coves.',
  camelford:
    'The Camel rises toward Bodmin Moor’s northern scarps—moor wind and stone sit above farmland draining to the north coast.',
  par:
    'St Austell Bay’s clay cliffs and sheltered docks link beach to freighter quays—industrial coast meets family sand in one cove.',

  cardiff:
    'The Vale shelves toward the Bristol Channel; Cardiff Bay’s lagoon is where the Taff and Ely meet salt water.',
  portsmouth:
    'Portsmouth Harbour’s islands and inlets compress navy, ferry and leisure fleets between the South Downs dip slope and the Solent tide race.',
  glasgow:
    'The Clyde widens through a post-industrial strath—Kelvin tributaries and drumlin edges once steered mill and shipyard growth.',
  london:
    'Thames terraces, gravel ridges and hidden tributary valleys still steer borough character from Richmond bends to the Lea floodplain.',
  birmingham:
    'The Rea and Tame corridor crosses Mercian mudstone plains—canal plateaux link the city toward Dudley and the Lickey Hills.',
  edinburgh:
    'Arthur’s Seat and the Crags rim the Old Town above the drained Nor Loch hollow, with the Firth of Forth opening northward.',
  manchester:
    'The Irwell, Medlock and Mersey headwaters gather on the Lancashire plain—benches and millstone grit edges frame northern upland views.',
  liverpool:
    'The Mersey estuary’s big tides and sandstone shores set Liverpool opposite heath-and-dune coast toward Formby and the Sefton plain.',
  leeds:
    'The Aire valley widens below gritstone Pennine fringes—terraces and goit channels underlie Leeds between moor edge and Vale of York flats.',
  bristol:
    'The Avon gorge cuts limestone through Clifton’s plateau—suspension bridges span tidal currents toward the Severn’s huge tidal range.',
  'newcastle-upon-tyne':
    'The Tyne’s steep gorge and Team valley scars meet North Sea skies at the Quayside—rivermouth cranes and mudflats signal Tyneside’s edge.',
  nottingham:
    'Sherwood sandstone beds and Trent gravel terraces sit above hidden caves on the Midland plain’s gentle swell.',
  sheffield:
    'Five rivers meet on the gritstone Pennine doorstep—Dark Peak moor falls into wooded cloughs before the Don’s steel-city mills.',
  brighton:
    'Chalk Downs end in sea cliffs where the London Clay low lets the Ouse reach Channel shingle—downland and beach define the strip.',
  oxford:
    'Gravel Thames terraces and the Cherwell–Isis floodplain curl around low limestone ridges—riverside meadows still steer the city edge.',
  norwich:
    'The Wensum meanders across glacial till on the northern Norfolk plain—shallow groundwater hints at the Broads a few miles downstream.',
  sunderland:
    'The Wear cuts a gorge through magnesian limestone to tight mouth beaches—denes and dunes link terraces to Roker’s North Sea front.',
  worcester:
    'The Severn’s wide vale shelves below the Malvern thrust front—flood meadow and bridge crossings define the riverside spine.',
  gloucester:
    'The Severn and Sharpness approach squeeze between Cotswold scarp brash and low Vale wetlands—tide can push salt far inland.',
  belfast:
    'Belfast Lough narrows between basalt plateau and the Castlereagh Hills—mudflats, basins and Cave Hill’s silhouette frame the ridgeline.',
  aberdeen:
    'Granite terraces climb from the Dee and Don mouths—dunes and high-energy North Sea surf lie beyond the beach esplanade.',
  southampton:
    'Southampton Water drowns former river valleys between the New Forest heath and the Itchen–Test estuaries—double tides mark the port edge.',
  cambridge:
    'Chalky boulder-clay lowlands drain through the Cam’s parallel lodes toward the Fens—flat horizons and willow-lined cuts typify the reach.',
  derby:
    'The Derwent exits the Peak District limestone edge onto Midland coal measures—terraces link stone country to Trent-fed industry.',
  hull:
    'The Humber sucks Trent and Ouse waters toward Spurn’s shifting spit—vast mudflats set Hull’s eastern horizon.',
  swansea:
    'Swansea Bay curves between the Gower promontory and the lower Tawe–Neath coast—sand beaches face Atlantic westerlies straight on.',
  'stoke-on-trent':
    'North Staffordshire coal and clay measures rise in low ridges—six towns sit on upper Trent tributaries that once fired potteries.',
  middlesbrough:
    'The Tees cuts through Jurassic ironstone scarps toward North Sea quays—Cleveland Hills sit above Teesside’s estuary flats.',
  reading:
    'Kennet meets Thames gravel terraces west of London—chalk-stream clarity and floodplain grazing shape the Thames Valley tech corridor.',
  northampton:
    'The Nene crosses Jurassic ironstone and limestone benches on the Northamptonshire upland—clay vales separate the town from Welland fens.',
  ipswich:
    'The Orwell ria and Gipping dockland link Suffolk’s till plain to the North Sea—mud-rich estuary and heath frame waterfront cranes.',
  coventry:
    'Sherbourne brooks drain the Warwickshire Arden clay belt toward the Avon—wetland pockets and ridge-and-furrow fields sit under suburban rims.'
};
